module.exports = __webpack_public_path__ + "img/trashIcon.90362376.svg";